import type { MetaFunction } from "react-router";
import { SITE_NAME } from "@/lib/constants";
import BlogIndex from "@/pages/BlogIndex";

export const meta: MetaFunction = () => [
  { title: `Blog | ${SITE_NAME}` },
  {
    name: "description",
    content: "Updates, tutorials, and insights from the LoadLogo team.",
  },
  { property: "og:title", content: `Blog | ${SITE_NAME}` },
  {
    property: "og:description",
    content: "Updates, tutorials, and insights from the LoadLogo team.",
  },
  { property: "og:type", content: "website" },
  { property: "og:url", content: "https://loadlogo.com/blog" },
  { property: "og:site_name", content: SITE_NAME },
  { name: "twitter:card", content: "summary_large_image" },
];

export default function BlogRoute() {
  return <BlogIndex />;
}
